module.exports = __webpack_public_path__ + "img/welcome.0082e379.png";